export const paymentStatus = {
  "PENDING_PAYMENT": "Pending",
  "CANCELLED": "Cancelled",
  "EXPIRED": "Expired",
  "PAID_FOR": "Paid",
  "TICKETED": "Ticketed",
  "READY_TO_TICKET": "Awaiting Ticket"
}
